// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  display: inline-block;
  text-decoration: none;
  text-decoration-skip-ink: auto;
  color: inherit;
  position: relative;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
}

a:hover{
  color: #af8559;
}


ul {
  display: flex;
  flex-direction: row;
}

li {
  padding: .5rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ProjectById/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["a {\n  display: inline-block;\n  text-decoration: none;\n  text-decoration-skip-ink: auto;\n  color: inherit;\n  position: relative;\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\na:hover{\n  color: #af8559;\n}\n\n\nul {\n  display: flex;\n  flex-direction: row;\n}\n\nli {\n  padding: .5rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
